/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, Map, fromJS } from 'immutable';
import * as Types from './types';
import type { SummaryType } from './types';
import type { Action } from 'trustar/utils/redux-types.js';
import {
  FETCH_SUMMARY,
  FETCH_SUMMARY_SUCCESS,
  FETCH_SUMMARY_FAILURE,
  CLEAR_SUMMARY,
  SHOW_ENTIRE_SUMMARY_TOGGLE,
  FOLD_ENTIRE_SUMMARY,
  FETCH_CS_ENCLAVE_SOURCE_MAP,
  FETCH_CS_ENCLAVE_SOURCE_SUCCESS,
  FETCH_CS_ENCLAVE_SOURCE_FAILURE,
} from './action-types.js';

import {REPLACE_SELECTION as NODE_REPLACED_IN_CONSTELLATION} from 'modules/constellation/action-types.js'
import {FETCH_SUMMARIES_FOR_REPORTS_SUCCESS} from './action-types';

export const current = (state: SummaryType = Types.Summary(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUMMARY_SUCCESS:
    return payload;
  case FETCH_SUMMARY_FAILURE:
    return Types.Summary();
  default:
    return state;
  }
};

export const summaries = (state: Map<String, SummaryType> = Map(), action: Action<*>) => {
  const {type, payload} = action;

  switch (type) {
    case FETCH_SUMMARY_SUCCESS:
      const reportId = payload.get('reportId', '');
      return state.set(reportId, payload);
    case FETCH_SUMMARIES_FOR_REPORTS_SUCCESS:
      const reportIdList = payload.get('items', '');
      const summariesMergedToState = reportIdList
        .reduce((finalOutput, currentSummary) => {
          // If this summary item has a reportId, add it/replace the current summary entry for that ID
          const summaryReportId = currentSummary.get('reportId', '');

          return summaryReportId ?
            finalOutput.set(summaryReportId, currentSummary) : finalOutput
        }, state); // <-- state here is the init value of the reduce function

      return summariesMergedToState;
    default:
      return state;
  }
};

export const hasSummary = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
  case FETCH_SUMMARY_SUCCESS:
    return true;
  case CLEAR_SUMMARY:
  case FETCH_SUMMARY_FAILURE:
    return false;
  default:
    return state;
  }
}

export const loading = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
  case FETCH_SUMMARY:
    return true;
  case FETCH_SUMMARY_SUCCESS:
  case FETCH_SUMMARY_FAILURE:
    return false;
  default:
    return state;
  }
};
export const summaryFullyExpanded = (state: boolean = false, action: Action<any>) => {
  const { type, payload } = action;
  switch (type) {
  case SHOW_ENTIRE_SUMMARY_TOGGLE:
    if (payload && payload.hasOwnProperty('show')) {
      return payload.show;
    } else {
      return !state;
    }
  default:
    return state;
  }
};

const enclaveClosedSourceMapping = (state: OrderedMap<any, any> = OrderedMap(), action: Action<string>) => {
  const { type, payload } = action;

  switch(type) {
    case FETCH_CS_ENCLAVE_SOURCE_SUCCESS:
    return payload;
  default:
    return state;
  }
};

export default combineReducers({
  current,
  loading,
  hasSummary,
  summaries,
  summaryFullyExpanded,
  enclaveClosedSourceMapping,
});



// WEBPACK FOOTER //
// ./src/app/modules/summaries/stores.js